import { render, staticRenderFns } from "./CreateTenant.vue?vue&type=template&id=2a0152db&scoped=true"
import script from "./CreateTenant.vue?vue&type=script&lang=js"
export * from "./CreateTenant.vue?vue&type=script&lang=js"
import style0 from "./CreateTenant.vue?vue&type=style&index=0&id=2a0152db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0152db",
  null
  
)

export default component.exports